import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { toaster } from "@/utilities/toaster";
import EmployeeModule from "@/store/modules/employee.module";
import { EmployeeModel } from "@/store/models/employees/addEmployee";
import Loader from "../../../components/widgets/loader.vue";
import employeeModule from "@/store/modules/employee.module";
/**
 * Add Employee Components
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let AddEmployee = /** @class */ (() => {
    let AddEmployee = class AddEmployee extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.pageIsLoading = true;
            this.ctaButtons = [{ routeName: "Employees" }];
            this.title = "Add Employee";
            this.userName = "";
            this.designationsName = "";
            this.selectedUserId = "";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Employees",
                    to: "/employees",
                },
                {
                    text: "Add Employee",
                    active: true,
                },
            ];
            this.employee = new EmployeeModel();
        }
        saveEmployee() {
            this.validate("newEmployeeObserver").then((response) => {
                if (response) {
                    if (this.employee.dateOfBirth != null) {
                        this.employee.dateOfBirthAsString = this.dateFormattedString(this.employee.dateOfBirth);
                    }
                    var user, desination;
                    if (this.userName != "") {
                        var username = this.userName.toLowerCase();
                        user = this.filteredUsers.find((user) => user.value.toLowerCase() === username);
                    }
                    if (user != null || user != undefined) {
                        this.employee.reportingTo = user.id;
                    }
                    if (this.designationsName != "") {
                        var designationsName = this.designationsName.toLowerCase();
                        desination = this.filtereddesignations.find((designation) => designation.designationName.toLowerCase() === designationsName);
                    }
                    if (desination != null || desination != undefined) {
                        this.employee.designationId = desination.id;
                    }
                    this.employee.dateOfJoinAsString = this.dateFormattedString(this.employee.dateOfJoin);
                    EmployeeModule.SaveEmployee(this.employee).then((response) => {
                        toaster.ShowSuccess("Employee was created successfully.");
                        this.$router.push({ name: "Employees" });
                    });
                }
            });
        }
        cancel() {
            this.$router.push({ name: "Employees" });
        }
        get users() {
            return employeeModule.users;
        }
        get filteredUsers() {
            if (this.userName != "") {
                const matchedUsers = this.users.filter((user) => user.value.toLowerCase().includes(this.userName.toLowerCase()));
                return matchedUsers;
            }
            else {
                return this.users;
            }
        }
        get designations() {
            return employeeModule.designations;
        }
        get filtereddesignations() {
            if (this.designationsName != "") {
                const matcheddesignations = this.designations.filter((user) => user.designationName.toLowerCase().includes(this.designationsName.toLowerCase()));
                return matcheddesignations;
            }
            else {
                return this.designations;
            }
        }
        //Lifecycle
        created() {
            this.pageIsLoading = false;
        }
    };
    AddEmployee = __decorate([
        Component({
            name: "AddEmployee",
            components: {
                Layout,
                PageHeader,
                Loader,
            },
        })
    ], AddEmployee);
    return AddEmployee;
})();
export default AddEmployee;
